module.exports = __webpack_public_path__ + "static/media/card-unionpay.a14fd9af.svg";